import axios from 'axios';
import momenttz from 'moment-timezone';
import { API_HOST } from '../../utils/request';

export const getEntrataData = async (integrationId) => {
  const res = await axios.get(
    `https://api.directual.com/good/api/v5/data/message/getAndCreateMessage?appID=f1a3bb81-3aba-43fb-8369-be1c35b3aa83&messageId=${integrationId}`
  );

  if (res.data.payload[0]?.data) {
    return JSON.parse(res.data.payload[0].data);
  }

  return {};
};

const getUrlParamsForEventData = () => {
  const query = new URLSearchParams(window.location.search);
  const visitor_uuid = query.get('visitor_uuid') || '';
  const visit_uuid = ''; //visit_uuid 
  return { visitor_uuid, visit_uuid };
};

export const convert_date_by_tz = async (date, tz) => {
  if (tz == 'MST') {
    return momenttz(date).tz('America/Denver'); // MST
  } else if (tz == 'PST') {
    return momenttz(date).tz('America/Los_Angeles'); // PST
  }
};
const getStoredTrackingData = () => {
  try {
    const stored = localStorage.getItem('lm_tracking_data');
    return stored ? JSON.parse(stored) : {};
  } catch (e) {
    return {};
  }
};

let trackingData = getStoredTrackingData();

const handleMessage = (event) => {
  // Listen for LM_TRACKING_DATA from parent
  if (
    event.data &&
    (event.data.type === 'LM_TRACKING_DATA' ||
      event.data.event_type === 'LM_TRACKING_DATA')
  ) {
    const data = event.data.payload || event.data.details || event.data;
    console.log('Tracking data captured in Widget Utilities:', data);
    trackingData = data;
    try {
      localStorage.setItem('lm_tracking_data', JSON.stringify(trackingData));
    } catch (e) {
      console.error('Failed to save tracking data', e);
    }
  }
  if (event.data?.event_type === 'form_submission') {
    console.log('event received in widget:', event.data);
  }
};

window.addEventListener('message', handleMessage, false);

// Handshake: Signal parent that the widget is ready to receive data (and request initial tracking data)
const signalReady = () => {
  if (window.parent !== window) {
    window.parent.postMessage({ type: 'CTA_IFRAME_LOADED' }, '*');
  }
};

// Signal readiness at different intervals to ensure parent catch it
if (document.readyState === 'complete') {
  signalReady();
} else {
  window.addEventListener('load', signalReady);
}
// Robust delays to catch parent listeners
[500, 2000].forEach((delay) => setTimeout(signalReady, delay));



export const saveLeadinDB = async (magnet_uuid, details) => {
  window.parent.postMessage(
    {
      event_type: 'form_submission',
      app_name: 'mini-apps',
      // ...details,
      details: {
        form_data: {
          lead_name: details?.form_data?.lead_name,
          lead_email: details?.form_data?.lead_email,
          lead_phone: details?.form_data?.lead_phone,
          tourTime: details?.form_data?.tourTime,
        },
      },
    },
    '*'
  );
  window.postMessage(
    {
      event_type: 'form_submission',
      app_name: 'mini-apps',
      details: {
        form_data: {
          lead_name: details?.form_data?.lead_name,
          lead_email: details?.form_data?.lead_email,
          lead_phone: details?.form_data?.lead_phone,
          tourTime: details?.form_data?.tourTime,
        },
      },
    },
    '*'
  );

  // Request/Refresh latest tracking data from parent before submission
  if (window.parent !== window) {
    window.parent.postMessage({ type: 'CTA_IFRAME_LOADED' }, '*');
    // Short grace period to allow parent to push data and local listener to process it
    await new Promise((resolve) => setTimeout(resolve, 300));
    trackingData = getStoredTrackingData();
    console.log('Refreshed tracking data for submission:', trackingData);
  }

  const res = await axios.post(`${API_HOST}/event`, {
    ...getUrlParamsForEventData(),
    magnet_uuid,
    url: window.location.href,
    event_type: 'form_submission',
    details,
    tracking: trackingData,
  });

  console.log('RESPONSE', res);

  // const jitsu = jitsuClient({
  //   key: 'js.oj1e1srp87oijohgjo9fyr.9b4uph2lmcwy2a9khx9o6o',
  //   tracking_host: 'https://t.jitsu.com',
  // });
  // jitsu.track('form_submission', {
  //   magnet_uuid,
  //   event_type: 'form_submission',
  //   details: {
  //     form_data: {
  //       lead_name: details?.form_data?.lead_name,
  //       lead_email: details?.form_data?.lead_email,
  //       lead_phone: details?.form_data?.lead_phone,
  //     },
  //   },
  // });
};
